module.exports = __webpack_public_path__ + "static/uminek.ooo_01-69bacdb10a216d1f1729b2151bd1144c.jpg";